import { createContext, useContext, ReactNode } from 'react';
import { CommunityId } from '../model/community.types';

// Community-scoped values shared by every node under the active community
// (identity + permissions). Post-specific data (post, postId, pinnedCount)
// stays in props; these are constant across the whole community subtree.
type CommunityContextValue = {
  communityId: CommunityId;
  influencerId?: string;
  canModerate: boolean;
  isDmFeatureEnabled: boolean;
  isContentEditEnabled: boolean;
};

const CommunityContext = createContext<CommunityContextValue | null>(null);

type ProviderProps = CommunityContextValue & {
  children: ReactNode;
};

export const CommunityProvider = ({ children, ...value }: ProviderProps) => (
  <CommunityContext.Provider value={value}>
    {children}
  </CommunityContext.Provider>
);

export const useCommunityContext = (): CommunityContextValue => {
  const value = useContext(CommunityContext);
  if (value === null) {
    throw new Error(
      'useCommunityContext must be used within a CommunityProvider',
    );
  }
  return value;
};
